module.exports = __webpack_public_path__ + "img/upload_logo.c5864af7.png";